<template>
  <div class="sysNotice app-container">
    <div class="global-header-wrap">
      <h3>系统通知管理</h3>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header">
        <div class="global-table-header">
          <div class="sysNotice-header-btn-left">
            <list-search ref="listSearch" @listSearchEvn="listSearchFun" />
          </div>
          <div class="sysNotice-header-right">
            <button
              class="global-button-style"
              @click="$router.push({ name: 'sysNoticeOperation' })"
            >
              新增系统通知
            </button>
          </div>
        </div>
      </div>
      <div class="global-body-wrap">
        <appTable
          :tableData="tableData"
          :tableProps="tableProps"
          :selectCtrl="false"
          @tableHandle="tableHandle"
        />
      </div>
      <pagination
        :pageSize="params.limit"
        :total="total"
        @pageNum="getPageNum"
      />
    </el-card>
    <el-dialog
      title="标签详情"
      :visible.sync="centerDialogVisible"
      width="50%"
      center
    >
      <div v-if="tagItem">
        <div class="sysNotice-dialog-item">
          <p>标题</p>
          <p>{{ tagItem.title }}</p>
        </div>
        <!-- <div class="sysNotice-dialog-item">
          <p>设备语言</p>
          <p>{{ tagItem.langs.join("\\") }}</p>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import listSearch from "@/components/listSearch";
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
export default {
  components: {
    listSearch,
    appTable,
    pagination
  },
  computed: {
    tableProps() {
      let tableProps = [
        {
          prop: "title",
          label: "标题"
        },
        {
          prop: "isNeedPopup",
          label: "是否弹窗显示"
        },
        {
          prop: "endAt",
          label: "截止时间"
        },
        {
          prop: "sysNotice_status",
          label: "是否过期"
        },
        {
          prop: "updatedAt",
          label: "创建时间"
        },
        {
          prop: "handle",
          label: this.$t("commonMsg.handle"),
          btn: [
            this.$t("commonMsg.edit"),
            // this.$t("commonMsg.checkDetails"),
            this.$t("commonMsg.del")
          ]
        }
      ];
      return tableProps;
    }
  },
  mixins: [listMixin],
  data() {
    return {
      ruleForm: {
        name: "",
        langs: ""
      },
      params: {
        limit: 20,
        page: 1,
        sortBy: "updatedAt"
      },
      tableData: [],
      total: 0,
      title: "",
      tagItem: null,
      centerDialogVisible: false
    };
  },
  methods: {
    async getList() {
      let res = await this.$http.getSysNotice(this.params);
      this.tableData = res.data.results;
      this.total = res.data.count;
    },

    async del(data) {
      await this.$http.delSysNotice(data.row._id);
      this.getList();
      this.elMsg("删除成功", "success");
    },

    toDetails(data) {
      this.tagItem = data.row;
      this.centerDialogVisible = true;
    },

    edit(data) {
      this.$router.push({
        name: "sysNoticeOperation",
        query: { id: data.row._id }
      });
    },

    getPageNum(page) {
      this.params.page = page;
      this.getList();
    },

    listSearchFun(val) {
      if (val) {
        this.params.title = val;
      } else {
        delete this.params.title;
      }
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.sysNotice {
  .sysNotice-btn {
    text-align: right;
    padding: 10px;
  }
  .sysNotice-pagination {
    padding: 10px;
    text-align: right;
  }
  .sysNotice-dialog-item {
    padding: 10px 0;
    line-height: 25px;
    > p:first-child {
      font-weight: bold;
    }
  }
}
</style>
